import {Layout} from '@/layout'

let routers = [
  {
    path: '/operatorManagement',
    component: Layout,
    children: [
      {
        path: 'opLog',
        meta: {
          isMenu: false,
          title: '运营商接口操作日志'
        },
        component: () => import('@/views/operatorManagement/operatorOpLog.vue')
      },
      {
        path: 'accountOpLog',
        meta: {
          isMenu: false,
          title: '运营商操作日志'
        },
        component: () => import('@/views/operatorManagement/operatorAccountOpLog.vue')
      }
    ]
  }
]

export default routers


